var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChipLabelInput',{attrs:{"value":_vm.value,"chip-placeholder":'{{measure_label}}',"chip-label":"KPI Measure Label","chip-tooltip":"Each KPI's measure name will be inserted at chip position","show-add-button":true,"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }